import { withInstall } from "../utils/index.mjs";
import _Loading from "./Loading.mjs";
const Loading = withInstall(_Loading);
var stdin_default = Loading;
import { loadingProps } from "./Loading.mjs";
export {
  Loading,
  stdin_default as default,
  loadingProps
};
